import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import * as moment from 'moment-timezone';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-t1-year',
  templateUrl: './select-t1-year.component.html',
  styleUrls: ['./select-t1-year.component.scss']
})
export class SelectT1YearComponent implements OnInit {

  public items: any[] = [];
  public months: any = [this.gasprecioService.capitalizeFirstLetter(moment().format('MMM YY'))];
  private lastMonthSelected: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService,
    private gasprecioService: GasprecioService
  ) { }

  ngOnInit(): void {
    const startDate = moment('2024-01-01');
    const endDate = moment();
    if (startDate.isBefore(endDate)) {
      let date = startDate.clone().startOf('month');
      const endLimit = endDate.clone().endOf('month');
      while (date.isSameOrBefore(endLimit)) {
        this.items.push({
          name: this.gasprecioService.capitalizeFirstLetter(date.format('MMMM YY')),
          startDate: date.clone().startOf('month').format('YYYY-MM-DD'),
          endDate: date.clone().endOf('month').format('YYYY-MM-DD')
        });
        date = date.clone().add(1, 'month');
      }
      this.items.reverse();
      this.months = [this.gasprecioService.capitalizeFirstLetter(endDate.format('MMMM YY'))];

      this.lastMonthSelected = this.sharedService.sharedT1Dashboard2.subscribe((selectedMonth: string) => {
        this.months = selectedMonth
          ? this.gasprecioService.capitalizeFirstLetter(moment(selectedMonth, 'YYYY-MM-DD').format('MMMM YY'))
          : this.gasprecioService.capitalizeFirstLetter(endDate.format('MMMM YY'));
      });
    }
  }

  ngOnDestroy(): void {
    if (this.lastMonthSelected) {
      this.lastMonthSelected.unsubscribe();
    }
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  changeMonthsAgo(event: any) {
    this.months = event;
    this.items.map((e) => {
      if (e.name === event) {
        this.sharedService.nextT1Dashboard2 = e.startDate;
      }
    });
  }
}

